export var CalibrationExpires;
(function (CalibrationExpires) {
    CalibrationExpires["ONEWEEK"] = "oneWeek";
    CalibrationExpires["TWOWEEKS"] = "twoWeeks";
    CalibrationExpires["ONEMONTH"] = "oneMonth";
    CalibrationExpires["SIXMONTHS"] = "sixMonths";
    CalibrationExpires["ONEYEAR"] = "oneYear";
    CalibrationExpires["THREEYEARS"] = "threeYears";
})(CalibrationExpires || (CalibrationExpires = {}));
